import React from 'react';
import { ReactSVG } from 'react-svg';

import { importStatic } from 'utils';

const DessertWithTumble = () => {
  return (
    <React.Fragment>
      <ReactSVG src={importStatic('/ui-router/images/desertbgFix.svg')} />
      <div className="shadow" />
      <ReactSVG
        src={importStatic('/ui-router/images/tumbleweed.svg')}
        afterInjection={(err, svg) => {
          if (!err) {
            svg.id = 'tumbleweed';
          }
        }}
      />
    </React.Fragment>
  );
};

// To render dessert with tumbleweed
export default DessertWithTumble;
